module.exports = __webpack_public_path__ + "search-icon.69a9e66084704a2f62e73a0a855dabaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-icon.png
// module id = 1156
// module chunks = 0